export default __webpack_public_path__ + "static/projectPlanner-5e642e6e21ae3eecc30e97fbcc511594.png";